export const portfolioData = [
  {
    title: "Moving Company",
    url: "https://preview-96615afa-96df-48ad-af18-58c708ddbb0a.greta.questera.ai/",
    description: "A comprehensive platform for residential and commercial relocation services, featuring real-time quote generation and scheduling."
  },
  {
    title: "Cleaning Company",
    url: "https://preview-b1df2b1d-1a58-44e1-a579-07021e90077f.greta.questera.ai/",
    description: "Professional sanitation and home organization interface with automated recurring booking systems."
  },
  {
    title: "Locksmith",
    url: "https://preview-6a117efd-477f-4425-8633-8b89626cc0f9.greta.questera.ai/",
    description: "High-response emergency service landing page optimized for mobile users requiring immediate roadside or residential assistance."
  },
  {
    title: "Pool Cleaning",
    url: "https://preview-d58e5c33-2f27-477f-ac7d-8a216f34c2db.greta.questera.ai/",
    description: "Specialized maintenance portal for pool chemical balancing, equipment repairs, and seasonal opening/closing services."
  },
  {
    title: "Window Cleaning",
    url: "https://preview-dd60810f-c563-46ca-ac51-41900c814e80.greta.questera.ai/",
    description: "Exterior maintenance showcase focusing on residential and commercial glass clarity and safety standards."
  },
  {
    title: "Pool Cleaning (Secondary)",
    url: "https://preview-1bd3b194-a559-4483-82e7-2b2720d18571.greta.questera.ai/",
    description: "Advanced aquatic facility management site featuring leak detection and structural repair service listings."
  },
  {
    title: "Tree Trimming",
    url: "https://preview-78cf68f2-c943-4e68-bc96-051b4389fd04.greta.questera.ai/",
    description: "Arborist-led digital presence for tree health assessments, precision pruning, and emergency storm cleanup."
  },
  {
    title: "Painting Company",
    url: "https://preview-ce65e683-5c92-4ebf-866d-3a76a7f8f9c3.greta.questera.ai/",
    description: "High-end interior and exterior painting services with integrated color theory consultation modules."
  },
  {
    title: "Flooring Business",
    url: "https://preview-25891bf7-df36-4896-b7a6-6ebb7b0a949d.greta.questera.ai/",
    description: "Installation-focused landing page showcasing hardwood, tile, and luxury vinyl plank flooring solutions."
  },
  {
    title: "Cleaning (Sanitation)",
    url: "https://preview-f0cc6765-fe45-4497-9786-a425183787c5.greta.questera.ai/",
    description: "Medical-grade deep cleaning and industrial sanitation services for corporate and office environments."
  },
  {
    title: "Backyard Fencing",
    url: "https://preview-5cb4fc2d-fb00-49bb-b9ab-f2930058317d.greta.questera.ai/",
    description: "Custom boundary solutions focusing on privacy, security, and aesthetic enhancement for residential landscapes."
  },
  {
    title: "Painting Company (Commercial)",
    url: "https://preview-8159f217-8dda-4d8e-907d-f5be644df5bd.greta.questera.ai/",
    description: "Industrial-scale painting and protective coating services for warehouses and large retail facilities."
  },
  {
    title: "Garage Installation",
    url: "https://preview-14d0079a-1bd8-4917-89da-ee52e419f256.greta.questera.ai/",
    description: "Smart garage door integration and structural installation services for modern residential designs."
  },
  {
    title: "Cleaning Company (Eco)",
    url: "https://preview-e83cf9af-b99d-4803-8722-28fae39181c2.greta.questera.ai/",
    description: "Environmentally conscious residential cleaning services utilizing non-toxic, pet-safe sanitation protocols."
  },
  {
    title: "Auto Detailing",
    url: "https://preview-b03d8d59-ed18-45a0-8017-f988e3898c2e.greta.questera.ai/",
    description: "Luxury mobile detailing platform with ceramic coating and paint correction service tiers."
  },
  {
    title: "Electrician",
    url: "https://preview-14218e8b-a93b-4148-8945-80cbac387561.greta.questera.ai/",
    description: "Certified electrical troubleshooting, panel upgrades, and smart home infrastructure implementation."
  },
  {
    title: "Power Washing",
    url: "https://preview-ea1851ea-129d-486f-9ea9-b82f282c744f.greta.questera.ai/",
    description: "High-pressure surface restoration for driveways, siding, and commercial building exteriors."
  },
  {
    title: "Pest Control",
    url: "https://preview-2508a3d8-376e-46a8-8b61-5c52f19abd59.greta.questera.ai/",
    description: "Scientific pest management solutions for residential prevention and industrial eradication."
  },
  {
    title: "Handyman",
    url: "https://preview-edb202a5-e18d-4d39-89f0-0e0902509768.greta.questera.ai/",
    description: "General home repair and maintenance portal for small-scale carpentry, plumbing, and electrical fixes."
  },
  {
    title: "Landscaping",
    url: "https://preview-32d7221a-8803-440b-8524-7e907d64028c.greta.questera.ai/",
    description: "Comprehensive outdoor design and lawn care management for residential properties."
  },
  {
    title: "Solar Panels",
    url: "https://preview-cafae306-4441-44d3-bb28-471bc0c1994f.greta.questera.ai/",
    description: "Sustainable energy consultation and solar array installation services for residential grid independence."
  },
  {
    title: "Junk Hauling",
    url: "https://preview-faa2612d-eb5b-4cd1-b9c7-00710cba4b5f.greta.questera.ai/",
    description: "Eco-friendly debris removal and responsible disposal services for site cleanouts and renovations."
  },
  {
    title: "Plumbing",
    url: "https://preview-475ebc5c-6d7c-4986-90d2-b61ef5319f28.greta.questera.ai/",
    description: "Emergency hydraulic repair and new fixture installation services with 24/7 availability."
  },
  {
    title: "Home Security",
    url: "https://preview-58bc505b-c7df-4fc9-ab50-3d130da5c7ce.greta.questera.ai/",
    description: "Advanced surveillance and alarm system integration for modern smart-home protection."
  }
];